import React from 'react';
import { Link } from 'react-router-dom';

const PlanesDetalle = () => {

  // 🔥 FUNCIÓN GLOBAL WHATSAPP
  const enviarWhatsApp = (plan) => {
    const mensaje = `Hola, quiero información del plan ${plan}`;
    const url = `https://wa.me/528719593901?text=${encodeURIComponent(mensaje)}`;
    window.open(url, "_blank");
  };

  return (
    <div className="relative min-h-screen bg-black text-white font-sans overflow-x-hidden">

      {/* VIDEO DE FONDO */}
      <div className="fixed inset-0 z-0">
        <video 
          autoPlay 
          loop 
          muted 
          playsInline 
          className="w-full h-full object-cover opacity-30"
        >
          <source src="/assets/video-planes.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-gradient-to-b from-black via-transparent to-black"></div>
      </div>

      {/* CONTENIDO */}
      <div className="relative z-10 container mx-auto px-6 pt-32 pb-12">

        {/* VOLVER */}
        <div className="mb-10">
          <Link 
            to="/" 
            className="group inline-flex items-center text-zinc-400 hover:text-yellow-400 transition-all uppercase text-[10px] font-black tracking-[0.3em]"
          >
            <span className="mr-2 text-lg group-hover:-translate-x-1 transition-transform">←</span> 
            Volver al Inicio
          </Link>
        </div>

        {/* HEADER */}
        <header className="text-center mb-24">
          <h1 className="text-6xl md:text-8xl font-black uppercase tracking-tighter mb-4 italic leading-none">
            Nuestros <span className="text-yellow-400">Planes</span>
          </h1>
          <p className="text-zinc-500 tracking-[0.4em] uppercase text-[11px] font-bold">
            Protección sin fronteras: México & USA
          </p>
          <div className="h-1 w-20 bg-yellow-400 mx-auto mt-8 rounded-full"></div>
        </header>

        {/* BENEFICIOS */}
        <section className="grid md:grid-cols-2 gap-8 mb-32">
          <div className="bg-zinc-900/80 p-10 rounded-3xl border border-zinc-800">
            <h3 className="text-yellow-400 font-black uppercase text-xl mb-4 flex items-center gap-3">
              🛡️ Seguro por Muerte Natural
            </h3>
            <p className="text-zinc-300 italic">
              "Paz mental después de 6 meses". La deuda se condona al 100%.
            </p>
          </div>

          <div className="bg-zinc-900/80 p-10 rounded-3xl border border-zinc-800">
            <h3 className="text-yellow-400 font-black uppercase text-xl mb-4 flex items-center gap-3">
              ⚡ Muerte Accidental
            </h3>
            <p className="text-zinc-300 italic">
              Todo lo aportado se devuelve y el plan queda libre.
            </p>
          </div>
        </section>

        {/* PLANES */}
        <div className="grid lg:grid-cols-3 gap-8 mb-32">

          {/* ELITE */}
          <div className="bg-zinc-900 p-10 rounded-3xl flex flex-col justify-between">
            <div>
              <h2 className="text-4xl font-black mb-6">ELITE "C"</h2>
              <ul className="space-y-3 text-sm mb-10">
                <li>✓ Velación Integral</li>
                <li className="font-bold text-white">✓ Inversión al Doble</li>
                <li>✓ Traslado Nacional</li>
              </ul>
            </div>

            {/* 🔥 AHORA VA A WHATSAPP */}
            <button
              onClick={() => enviarWhatsApp('Elite C')}
              className="w-full py-4 border border-white rounded-full uppercase text-xs font-black hover:bg-white hover:text-black transition-all"
            >
              Afiliarme a este Plan
            </button>
          </div>

          {/* REGAZO */}
          <div className="bg-yellow-400 text-black p-10 rounded-3xl scale-105 flex flex-col justify-between">
            <div>
              <h2 className="text-4xl font-black mb-6">REGAZO</h2>
              <ul className="space-y-3 text-sm mb-10">
                <li className="font-bold">• Ataúd de Cedro</li>
                <li className="font-black">• Condonación Total</li>
                <li>• Asistencia Premier</li>
              </ul>
            </div>

            <button
              onClick={() => enviarWhatsApp('Regazo')}
              className="w-full py-4 bg-black text-white rounded-full uppercase text-xs font-black"
            >
              Solicitar Regazo
            </button>
          </div>

          {/* ITALIA */}
          <div className="bg-zinc-900 p-10 rounded-3xl flex flex-col justify-between">
            <div>
              <h2 className="text-4xl font-black mb-6">ITALIA</h2>
              <ul className="space-y-3 text-sm mb-10">
                <li>✓ Urnas Premium</li>
                <li className="font-bold text-white">✓ México y USA</li>
                <li>✓ Trámites Legales</li>
              </ul>
            </div>

            <button
              onClick={() => enviarWhatsApp('Italia')}
              className="w-full py-4 border border-white rounded-full uppercase text-xs font-black hover:bg-white hover:text-black transition-all"
            >
              Cotizar Plan Italia
            </button>
          </div>

        </div>

      </div>
    </div>
  );
};

export default PlanesDetalle;